<!-- SKELETON-LOADER -->
<div class="formsReport__card formsReport__card__topic" *ngIf="isLoading">
  <div class="formsReport__card__content">
    <div class="formsReport__card__content__card" *ngFor="let form of [0, 1, 2]">
      <ngx-skeleton-loader
        [theme]="{ height: '16px', width: '90%', 'margin-bottom': '0px', 'margin-top': '0px' }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{ height: '12px', width: '50%', 'margin-bottom': '24px', 'margin-top': '12px' }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{ height: '50px', width: '100%', 'margin-bottom': '0px', 'margin-top': '0px' }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>
<!-- /SKELETON-LOADER -->

<div class="formsReport__empty" *ngIf="!isLoading && !formReportsPage?.items?.length">
  <div class="formsReport__empty__content">
    <mat-icon class="row__item">search</mat-icon>
    <span class="subtitle-text row__item"> {{ 'DASHBOARD_FORMS.CARD.NO_RESULTS' | translate }} </span>
  </div>
</div>

<div class="formsReport__card formsReport__card__topic" *ngIf="!isLoading && formReportsPage?.items?.length">
  <div class="formsReport__card__content">
    <div class="formsReport__card__content__card" *ngFor="let form of formReportsPage.items">
      <div>
        <span class="formsReport__card__content__card-title">{{ form.formName }}</span>
      </div>
      <span class="formsReport__card__content__card-subtitle">
        {{ form.formAnswerCount }}
        {{ (form.formAnswerCount >= 2 ? 'DASHBOARD_FORMS.CARD.ANSWERS' : 'DASHBOARD_FORMS.CARD.ANSWER') | translate }}
      </span>
      <button
        class="formsReport__card__content__card-button"
        (click)="navigateToDetailPage(form)"
        [routerLinkActive]="['active', 'accent']"
      >
        {{ 'DASHBOARD_FORMS.CARD.BUTTON' | translate }}
      </button>
    </div>
  </div>
</div>

<mat-paginator
  class="formsReport__paginator"
  [ngClass]="{ 'formsReport__paginator--hidden': !formReportsPage?.items?.length }"
  [length]="totalCount"
  [pageSizeOptions]="[9, 12, 24, 30, 36]"
  [disabled]="isLoading"
></mat-paginator>
